<ion-card
  [class.tablet]="platform === platformRef.tablet"
  [class.mobile]="platform === platformRef.mobile"
>
  <div
    class="image-container"
    [class.mobile]="platform === platformRef.mobile"
    [class.tablet]="platform === platformRef.tablet"
  ></div>
  <div class="padding" [class.tablet]="platform === platformRef.tablet">
    <div class="text-container">
      <p class="small">
        {{ 'i18n.menuProfitPro.aiTile.title' | translate }}
      </p>
      <p
        class="innovate"
        [class.tablet]="platform === platformRef.tablet"
        [class.mobile]="platform === platformRef.mobile"
      >
        {{ 'i18n.menuProfitPro.aiTile.subTitle' | translate }}
      </p>
      <ion-button class="usf-outline-green-button">
        {{ 'i18n.menuProfitPro.imageTiles.descriptors.comeSoon' | translate }}
        <!-- {{'i18n.menuProfitPro.aiTile.buttonText' | translate}} -->
      </ion-button>
    </div>
  </div>
</ion-card>
